'use client';

import { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button"; // Optional if you're using Shadcn
import { X } from 'lucide-react';

const COOKIE_NAME = 'cookie_consent';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_NAME);
    if (!consent) setIsVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_NAME, 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem(COOKIE_NAME, 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-white border border-gray-300 shadow-lg rounded-xl p-4 md:max-w-xl md:mx-auto flex flex-col md:flex-row items-center gap-4">
      <div className="flex-1 text-sm text-gray-700">
        This website uses cookies to enhance the user experience. By continuing, you agree to our use of cookies.
      </div>
      <div className="flex gap-2 mt-2 md:mt-0">
        <Button onClick={acceptCookies} className="bg-green-600 hover:bg-green-700 text-white text-sm">Accept</Button>
        <Button onClick={declineCookies} variant="outline" className="text-sm">Decline</Button>
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default CookieConsent;
